import React from 'react'
import {$, $$$} from '../shared/class-name'

export const LocationIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
</svg>

export const LockIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
</svg>
export const CookieIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z
        M9.5 8.5a1 1 0 1 1-2 0 1 1 0 1 1 2 0z
        M8.5 14.5a1 1 0 1 1-2 0 1 1 0 1 1 2 0z
        M15.5 15.5a1 1 0 1 1-2 0 1 1 0 1 1 2 0z"/>
</svg>

export const ArchiveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm3-5h8v2H8z"/>
</svg>

export const UnarchiveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm7-9l4 4h-2.5v3h-3v-3H8z"/>
</svg>

export const FilterIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 8l4 4-4 4"/>
    <path d="M18 8l-4 4 4 4"/>
</svg>

export const RemoveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
</svg>

export const RevertIcon = ({size = 16}) => <svg
    width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7h13a7 7 0 0 1 0 14H7"></path>
    <polyline points="8 2 3 7 8 12"></polyline>
</svg>

export const RefreshIcon = ({size = 16}) => <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round">
    <g transform="translate(12 12) scale(1.12) translate(-12 -12)">
        <path d="M21 12a9 9 0 0 0-15-6.7L3 8"></path>
        <path d="M3 3v5h5"></path>
        <path d="M3 12a9 9 0 0 0 15 6.7L21 16"></path>
        <path d="M21 21v-5h-5"></path>
    </g>
</svg>

export const RestoreIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 8.5h10.5a5.75 5.75 0 0 1 0 11.5H8" strokeWidth="3.2"/>
    <path d="M5 8.5l4.2-4.2M5 8.5l4.2 4.2" strokeWidth="3.8"/>
    <path d="M2.8 8.5H5" strokeWidth="1.8"/>
</svg>

export const RestoreAccountIcon = ({size = 24}) => <svg width={size} height={size} viewBox="1 1 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.2 18.3A8.2 8.2 0 1 0 5.2 11.6" strokeWidth="2"/>
    <path transform="scale(0.6) translate(4.2 9)" d="M.8 11.1h7.3c.5 0 .7.6.4.9l-4.1 4.1a.6.6 0 0 1-.9 0L.4 12c-.3-.3-.1-.9.4-.9z" fill="currentColor" stroke="none"/>
    <g transform="translate(8.2 7.5)">
        <ProfileIcon size={10}/>
    </g>
</svg>

export const CopyIcon = ({size = 16}) => <svg width={size} height={size} viewBox="-2 -1 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="8" y="8" width="11" height="11" rx="2"/>
    <path d="M5 15H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"/>
</svg>

export const ReplaceIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5 7.8c0-.72.58-1.3 1.3-1.3h9.35l-1.4-1.4a1.25 1.25 0 0 1 1.77-1.77l3.55 3.55c.49.49.49 1.28 0 1.77l-3.55 3.55a1.25 1.25 0 1 1-1.77-1.77l1.4-1.4H6.3C5.58 9.1 5 8.52 5 7.8z"/>
    <path d="M19 16.2c0 .72-.58 1.3-1.3 1.3H8.35l1.4 1.4a1.25 1.25 0 0 1-1.77 1.77l-3.55-3.55a1.25 1.25 0 0 1 0-1.77l3.55-3.55a1.25 1.25 0 0 1 1.77 1.77l-1.4 1.4h9.35c.72 0 1.3.58 1.3 1.3z"/>
</svg>

export const CompareIcon = ReplaceIcon

export const TrashIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6l-1 14H6L5 6"/>
    <path d="M10 11v6m4-6v6"/>
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
</svg>

export const ArrowLeftIcon = ({size = 16, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"/>
</svg>

export const ArrowRightIcon = ({size = 16, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>
</svg>

export const ArrowUpIcon = ({size = 16, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
</svg>

export const ArrowDownIcon = ({size = 16, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
</svg>

export const HorizontalIcon = ({size = 18, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 11v2h6v-2H9zM3 12l4-4v3h10V8l4 4-4 4v-3H7v3z"/>
</svg>

export const VerticalIcon = ({size = 18, className}) => <svg className={$$$($(className))} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11 9h2v6h-2V9zM12 3l-4 4h3v10H8l4 4 4-4h-3V7h3z"/>
</svg>

export const ScaleIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <g transform="translate(12 12) translate(-12 -12)">
        <path d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/>
        <path transform="translate(24 0) scale(-1 1)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/>
        <path transform="translate(0 24) scale(1 -1)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/>
        <path transform="rotate(180 12 12)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/>
    </g>
</svg>

export const ShrinkIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <g transform="translate(.7 -.7)"><path transform="rotate(180 17.2 7)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/></g>
    <g transform="translate(-.7 -.7)"><path transform="translate(24 0) scale(-1 1) rotate(180 17.2 7)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/></g>
    <g transform="translate(.7 .7)"><path transform="translate(0 24) scale(1 -1) rotate(180 17.2 7)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/></g>
    <g transform="translate(-.7 .7)"><path transform="rotate(180 12 12) rotate(180 17.2 7)" d="M14.25 8.25 17 5.5h-2.45c-.68 0-1.15-.47-1.15-1.15S13.87 3.2 14.55 3.2h5.35c.68 0 1.15.47 1.15 1.15V9.7c0 .68-.47 1.15-1.15 1.15s-1.15-.47-1.15-1.15V7.25L15.9 10.1c-.47.47-1.18.47-1.7-.05-.47-.47-.47-1.23.05-1.8z"/></g>
</svg>

export const VideoFocusIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.5 10.5 4 4m0 0h5M4 4v5"/>
    <path d="M13.5 13.5 20 20m0 0h-5m5 0v-5"/>
</svg>

export const VideoUnfocusIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4 10.5 10.5m0 0h-5m5 0v-5"/>
    <path d="M20 20 13.5 13.5m0 0h5m-5 0v5"/>
</svg>

export const BackgroundIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
</svg>

export const PublishIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"/>
</svg>

export const PinIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <g transform="rotate(38 12 12) translate(-1.2 0) scale(1.1 1)">
        <path d="M8 3h8l-1.4 5.2v2.5l2.7 2.4v2H6.7v-2l2.7-2.4V8.2L8 3z"/>
        <path d="M12 15v7"/>
    </g>
</svg>

export const UploadIcon = ({size = 16, strokeWidth = 1.75}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.5 8.5 12 4l4.5 4.5M12 4v9.5"/>
    <path d="M5 18v2h14v-2"/>
</svg>

export const ProcessingIcon = ({size = 16, strokeWidth = 2.25}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 3h10v2.5c0 2.5-4 4.3-4 6.5s4 4 4 6.5V21H7v-2.5c0-2.5 4-4.3 4-6.5S7 8 7 5.5z"/>
</svg>

export const AlbumArchiveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zm-8-4h2v2h-2v-2zm-2-2h6v2h-6v-2z"/>
</svg>

export const AlbumIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <AlbumGlyph/>
</svg>

export const MuteContentIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <AlbumGlyph/>
    <MuteSlash/>
</svg>

export const DraftIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
</svg>

export const ImportIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
</svg>

export const SearchIcon = ({size = 24}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
</svg>

export const QuestionMarkIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 9a3 3 0 1 1 4.5 2.6c-.95.55-1.5 1.1-1.5 2.4"/>
    <line x1="12" y1="18" x2="12" y2="18"/>
</svg>

export const MinusIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="6" y1="12" x2="18" y2="12"/>
</svg>

export const PlusIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 3.25c.966 0 1.75.784 1.75 1.75v5.25H19a1.75 1.75 0 1 1 0 3.5h-5.25V19a1.75 1.75 0 1 1-3.5 0v-5.25H5a1.75 1.75 0 1 1 0-3.5h5.25V5c0-.966.784-1.75 1.75-1.75z"/>
</svg>

export const ChevronRightIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"/>
</svg>

export const EditIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
</svg>

export const PlayIcon = ({size = 18}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 4.75C6 3.784 7.07 3.2 7.857 3.74l11.05 7.25c.723.474.723 1.556 0 2.03L7.857 20.26C7.07 20.8 6 20.216 6 19.25V4.75z"/>
</svg>

export const PauseIcon = ({size = 18}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <rect x="6" y="5" width="4" height="14" rx="1.5"/>
    <rect x="14" y="5" width="4" height="14" rx="1.5"/>
</svg>
export const VideoPreviousIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0.5 24 24"
    fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6.5 14.5 5.5-5 5.5 5"/>
</svg>
export const VideoNextIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 -0.5 24 24"
    fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6.5 9.5 5.5 5 5.5-5"/>
</svg>
export const VolumeIcon = ({size = 18}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5 6 9H3v6h3l5 4V5Z"/>
    <path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a8.5 8.5 0 0 1 0 12"/>
</svg>

export const VolumeMutedIcon = ({size = 18}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5 6 9H3v6h3l5 4V5Z"/>
    <path d="m16 9 5 6m0-6-5 6"/>
</svg>

export const PrevIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 18V6h2v12H6zm3-6l9 6V6l-9 6z"/>
</svg>

export const NextIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 6v12h2V6h-2zM6 18l9-6-9-6v12z"/>
</svg>

export const GridAdjustIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"/>
</svg>

export const ExpandIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
</svg>

export const CloseIconSmall = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
</svg>

export const MessageIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <MessageGlyph/>
</svg>

export const MuteMessagesIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <MessageGlyph/>
    <MuteSlash/>
</svg>

export const BlockMessagesIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <MessageGlyph/>
    <BlockBadge/>
</svg>

export const FollowingIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4z"/>
    <path d="M19 9v3h-3.5v2H19v3l4-4-4-4z"/>
</svg>

export const FollowerIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4z"/>
    <path d="M19.5 9l-4 4 4 4v-3H23v-2h-3.5V9z"/>
</svg>

export const MutualIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4z"/>
    <path d="M19 9v1.5h-3.5v1H19v1.5l4-2-4-2z"/>
    <path d="M19.5 13l-4 2 4 2v-1.5H23v-1h-3.5V13z"/>
</svg>

export const SuggestionsIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4z"/>
    <path d="M20 8c-1.66 0-3 1.34-3 3h1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 1-1.5 1.75-1.5 3.5h1.5c0-1.25 1.5-2.25 1.5-3.5 0-1.66-1.34-3-3-3zm-.75 8h1.5v1.5h-1.5z"/>
</svg>

export const ConnectionsIcon = ({size = 20}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
</svg>

export const PersonAddIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
</svg>

export const PersonRemoveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm17-5h-4v2h4v-2z"/>
</svg>

export const ChevronIcon = ({size = 16, isExpanded = false}) => <svg width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
    <path d={isExpanded ? 'M7 14.5 12 9.5l5 5' : 'M7 9.5l5 5 5-5'}/>
</svg>

export const ChevronLeftIcon = ({size = 16}) => <svg width={size} height={size} viewBox="1 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 18 9.55 12.55Q9 12 9.55 11.45L15 6"/>
</svg>

export const SettingsIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
</svg>

export const PortfolioIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
</svg>

export const ExternalLinkIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>
    <path d="M14 4h6v6"/>
    <path d="M10 14L20 4"/>
</svg>

export const AngledEarthIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.74 8.1h-3.09c-.45 0-.86-.24-1.08-.63l-1.02-1.78c-.2-.36-.58-.58-.99-.58h-2.21c-.38 0-.72.18-.94.49L8.98 9.62c-.26.36-.67.58-1.11.58H4.26A8.02 8.02 0 0 1 12 4c3.83 0 7.03 2.69 7.74 6.1zM4 12.02h4.52c.42 0 .79.25.95.63l.8 1.89c.18.43.6.71 1.07.71h1.8c.49 0 .92.31 1.08.77l.78 2.26c.11.32.36.57.67.7A7.94 7.94 0 0 1 12 20a8 8 0 0 1-8-7.98zm13.72 5.64-.82-2.38c-.35-1.02-1.31-1.7-2.38-1.7h-1.55c-.39 0-.74-.23-.89-.59l-.79-1.86c-.18-.43-.03-.93.36-1.19l1.53-1.02 1.12 1.96c.47.82 1.34 1.32 2.28 1.32h3.4a7.96 7.96 0 0 1-2.26 5.46z"/>
</svg>

export const SaveIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-4-4zm-5 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm3-10H5V5h10v4z"/>
</svg>

export const SendIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M2 21l21-9L2 3v7l15 2-15 2z"/>
</svg>

export const CloseIcon = ({size = 16, strokeWidth=3.5}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
</svg>

export const CameraIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
</svg>

export const DragHandleIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM9 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM9 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
</svg>

export const LikeIcon = ({size = 24}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
</svg>

export const CommentIcon = ({size = 24, strokeWidth=1.8}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.38 5.06L2 22l4.94-1.38A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
</svg>

export const BookmarkIcon = ({size = 24}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
</svg>

export const ShareIcon = ({size = 24}) => <svg width={size} height={size} viewBox="1 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="2.5"/>
    <circle cx="6" cy="12" r="2.5"/>
    <circle cx="18" cy="19" r="2.5"/>
    <line x1="8.4" y1="10.9" x2="15.6" y2="6.1"/>
    <line x1="8.4" y1="13.1" x2="15.6" y2="17.9"/>
</svg>

export const StarIcon = ({size = 24, fill = 'none', stroke = 'currentColor'}) => <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
</svg>

export const VideoIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="5" width="14" height="14" rx="3"/>
    <path d="M15 9.5 L22 6 L22 18 L15 14.5 Z"/>
</svg>

export const DiscussionIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <rect x="2" y="3" width="4" height="4" rx="2"/>
    <rect x="8" y="3" width="14" height="4" rx="2"/>
    <rect x="2" y="10" width="4" height="4" rx="2"/>
    <rect x="8" y="10" width="14" height="4" rx="2"/>
    <rect x="2" y="17" width="4" height="4" rx="2"/>
    <rect x="8" y="17" width="10" height="4" rx="2"/>
</svg>

export const HomeIcon = ({size = 20}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3.5a1 1 0 0 0-.664.252l-7 6.182A1 1 0 0 0 4 10.683V19a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-8.317a1 1 0 0 0-.336-.751l-7-6.182A1 1 0 0 0 12 3.5z"/>
</svg>

export const ExploreIcon = ({size = 20, className}) => <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
</svg>

export const ProfileIcon = ({size = 18}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <ProfileGlyph/>
</svg>

export const BlockUserIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <ProfileGlyph/>
    <BlockBadge/>
</svg>

export const LogoutIcon = ({size = 16}) => <svg width={size} height={size} viewBox="-2 0 24 24" fill="currentColor">
    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
</svg>

export const LoginIcon = ({size = 18}) => <svg width={size} height={size} viewBox="2 0 24 24" fill="currentColor">
    <path d="M11 7 9.59 8.41 12.17 11H4v2h8.17l-2.58 2.58L11 17l5-5-5-5zm8-4h-8v2h8v14h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
</svg>

export const MoreIcon = ({size = 16, strokeWidth=2.75}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <circle cx="5" cy="12" r={strokeWidth}/>
    <circle cx="12" cy="12" r={strokeWidth}/>
    <circle cx="19" cy="12" r={strokeWidth}/>
    {/*<circle cx="7" cy="8" r="3"></circle>*/}
    {/*<circle cx="12" cy="16" r="3"></circle>*/}
    {/*<circle cx="17" cy="8" r="3"></circle>*/}
</svg>
export const ListIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <circle cx="5" cy="6" r="1.5" fill="currentColor" stroke="none"/><path d="M9 6h10"/>
    <circle cx="5" cy="12" r="1.5" fill="currentColor" stroke="none"/><path d="M9 12h10"/>
    <circle cx="5" cy="18" r="1.5" fill="currentColor" stroke="none"/><path d="M9 18h10"/>
</svg>
export const BellIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
</svg>

export const FlagIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"/>
</svg>

export const BlockIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <BlockGlyph/>
</svg>

export const SortIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 18h6v-2H3v2zm0-5h12v-2H3v2zm0-7v2h18V6H3z"/>
</svg>

export const CalendarIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
</svg>

export const ClipIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M9 9h6v6H9z"/>
</svg>

export const RouteIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="6" r="2"/>
    <circle cx="19" cy="18" r="2"/>
    <path d="M5 8c0 4 4 6 7 6s7 2 7 6" strokeDasharray="3 2"/>
</svg>

export const TimelineRelationIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="12" y1="2" x2="12" y2="22"/>
    <circle cx="12" cy="6" r="2" fill="currentColor"/>
    <line x1="12" y1="6" x2="5" y2="11" strokeDasharray="2 2"/>
    <circle cx="12" cy="14" r="2" fill="currentColor"/>
    <line x1="12" y1="14" x2="19" y2="9" strokeDasharray="2 2"/>
</svg>
export const VisitedIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12C3 9.4 7.3 6 12 6S21 9.4 21 12S16.7 18 12 18S3 14.6 3 12Z"/>
    <circle cx="12" cy="12" r="2.75"/>
</svg>
export const MapIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
</svg>

export const VideosIcon = ({size = 14}) => <PlayIcon size={size}/>

export const RankingsIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M2 14h6v8H2zM9 10h6v12H9zM16 17h6v5h-6z"/>
</svg>

export const CheckIcon = ({size = 16, strokeWidth=5, opacity=.7}) => <svg width={size} height={size} viewBox="0 -1 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} opacity={opacity} strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
</svg>

export const ClockIcon = ({size = 16}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
</svg>

export const EarthIcon = ({size = 14}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
</svg>

const AlbumGlyph = () => <>
    <path d="M7 7V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-1"/>
    <rect x="3" y="7" width="14" height="14" rx="3"/>
    <path d="M6.5 16l2-2.5 1.5 1.75L12.25 12 15 16H6.5" fill="currentColor" stroke="none"/>
</>
const MessageGlyph = () => <path fillRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.38 5.06L2.5 21.5l4.94-.38A9.96 9.96 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zM9 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm4.5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm4.5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
const ProfileGlyph = () => <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
const BlockGlyph = () => <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/>
const MuteSlash = () => <>
    <path d="M4 4 20 20" fill="none" stroke="rgba(0, 0, 0, .82)" strokeWidth="5" strokeLinecap="round"/>
    <path d="M4 4 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
</>
const BlockBadge = () => <>
    <circle cx="17.7" cy="17.7" r="5.4" fill="var(--background-base)"/>
    <g transform="translate(12.5 12.5) scale(.43)"><BlockGlyph/></g>
</>
